import { Environment } from '../enum';

export const GOOGLE_ANALYTICS_CONFIG: Record<Environment, string> = {
  local: 'G-445MQYXL9T',
  stg: 'G-58RFEDHXKY',
  prod: 'G-1PH2CJJXV0',
};
